import {
    ICategoriaServicio,
    LOAD_CATEGORIAS_SERVICIOS_SUCCESS,
    ServicioAdicionalActionTypes, UPDATE_SERVICIO, UPDATE_SERVICIOS
} from "../types/servicioAdicionalType";
import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";

export function categoriaServicioReducer(state = [], action: ServicioAdicionalActionTypes): ICategoriaServicio[] {
    switch (action.type) {
        case LOAD_CATEGORIAS_SERVICIOS_SUCCESS:
            return action.categorias;
        default:
            return state;
    }
}

export function servicioAdicionalReducer(state: ServicioAdicional[] = [], action: ServicioAdicionalActionTypes): ServicioAdicional[] {
    switch (action.type) {
        case UPDATE_SERVICIOS:
            return action.serviciosAdicionales;
        case UPDATE_SERVICIO:
            return state.map(s => s.id !== action.servicioAdicional.id ? s : new ServicioAdicional(action.servicioAdicional));
        default:
            return state;
    }
}

